import React from 'react'
import { Button } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { updateUser } from 'actions/users'
import Password from 'components/Fields/Password'
import PasswordConfirmation from 'components/Fields/PasswordConfirmation'
import useFormExpanded from 'hooks/useFormExpanded'
import { setNotification } from 'actions/status'

export default function ResetPassword() {
  // TODO: In the future, both forgot pw and reset pw should probably be handled the exact same way -
  // with an email pw reset link
  const dispatch = useDispatch()
  const userId = useCurrentUserProp('id')
  const formMethods = useFormExpanded()
  const { hasErrors, handleSubmit, setFieldValidationErrors, control, watch } = formMethods
  const password = watch('password')

  function save(values) {
    dispatch(updateUser(userId, values)).then(() => {
      dispatch(setNotification('success', 'Password reset'))
    }).catch((errorResponse) => {
      setFieldValidationErrors(errorResponse)
    })
  }

  return (
    <form>
      <Password fullWidth control={control} />
      <PasswordConfirmation fullWidth password={password} control={control} />
      <Button disabled={hasErrors} onClick={handleSubmit(save)} size='large' fullWidth color='primary' variant='contained'>
        reset password
      </Button>
    </form>
  )
}
